import UserCargoOfficerListResponse, {
  UserCargoOfficerListResponseItem,
  UserCargoOfficerListResponseItemTaxiCorporation,
} from "../../../../api/raily/user/cargo-officer/list/user-cargo-officer-list.response";
import UserCargoOfficerList, {
  UserCargoOfficerListItem,
  UserCargoOfficerListItemTaxiCorporation,
} from "./user-cargo-officer-list";

const createAlternativePhoneNumber = (
  responseDataItem: UserCargoOfficerListResponseItem,
): UserCargoOfficerListItem["alternativePhoneNumber"] => {
  if (
    !responseDataItem.mobileSecondary ||
    !responseDataItem.mobileSecondaryPrefix
  ) {
    return null;
  }

  return {
    dialingCode: responseDataItem.mobileSecondaryPrefix,
    number: responseDataItem.mobileSecondary,
  };
};

const createPhoneNumber = (
  responseDataItem: UserCargoOfficerListResponseItem,
): UserCargoOfficerListItem["phoneNumber"] => {
  return {
    dialingCode: responseDataItem.mobilePrimaryPrefix,
    number: responseDataItem.mobilePrimary,
  };
};

const createTaxiCorporation = (
  responseTaxiCorporation: UserCargoOfficerListResponseItemTaxiCorporation,
): UserCargoOfficerListItemTaxiCorporation => {
  return {
    name: responseTaxiCorporation.companyName,
  };
};

const createDataItem = (
  responseDataItem: UserCargoOfficerListResponseItem,
): UserCargoOfficerListItem => {
  return {
    uuid: responseDataItem.id,
    removalDate: responseDataItem.removedAt,
    alternativePhoneNumber: createAlternativePhoneNumber(responseDataItem),
    cargoCompany: createTaxiCorporation(
      responseDataItem.cargoOfficer.cargoCompany!,
    ),
    email: responseDataItem.email,
    firstName: responseDataItem.firstName,
    lastName: responseDataItem.lastName,
    username: responseDataItem.username,
    phoneNumber: createPhoneNumber(responseDataItem),
  };
};

const createData = (
  responseData: UserCargoOfficerListResponseItem[],
): UserCargoOfficerListItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: UserCargoOfficerListResponse,
): UserCargoOfficerList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const userCargoOfficerListFactory = {
  create,
};

export default userCargoOfficerListFactory;
